import styled from "styled-components";

export const Content = styled.div`
  background-color: #000000;
  height: 551px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1919px) {
    background-color: #000000;
    height: 413px;
  }

  @media (max-width: 1365px) {
    background-color: #000000;
    height: 584px;
    flex-direction: column-reverse;
  }
`;

export const Content2 = styled.div`
  background-color: #000000;
  height: fit-content;
  margin-top: 50px;
  padding: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1919px) {
    background-color: #000000;
    height: fit-content;
  }

  @media (max-width: 1365px) {
    background-color: #000000;
    height: fit-content;
    flex-direction: column-reverse;
  }
`;

export const LeftColumn = styled.div`
  @media (max-width: 1365px) {
    margin-top: 32px;
  }
`;

export const BlackAsset = styled.div`
  background: url("/assets/asset-black-1920px.svg") center/cover no-repeat;
  width: 540px;
  height: 303px;

  @media (max-width: 1919px) {
    background: url("/assets/asset-black-1366px.svg") center/cover no-repeat;
    width: 385px;
    height: 216px;
  }

  @media (max-width: 1365px) {
    background: url("/assets/asset-black-mobile.svg") center/cover no-repeat;
    width: 248px;
    height: 140px;
  }
`;

export const BlackAsset2 = styled.div`
  background: url("/assets/asset-black2-1920px.svg") center/cover no-repeat;
  width: 418px;
  height: 76px;
  margin-left: 2.5rem;

  @media (max-width: 1919px) {
    background: url("/assets/asset-black2-1366px.svg") center/cover no-repeat;
    width: 298px;
    height: 54px;
    margin-left: 1.6rem;
  }

  @media (max-width: 1365px) {
    background: url("/assets/asset-black2-mobile.svg") center/cover no-repeat;
    width: 192px;
    height: 35px;
    margin-left: 1.2rem;
  }
`;

export const RightColumn = styled.div`
  margin-left: 41px;

  @media (max-width: 1365px) {
    display: flex;
    flex-direction: column;
    margin: 0;
  }
`;

export const Title = styled.h2`
  font-family: "Rubik";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 33px;
  text-transform: uppercase;
  color: #f8d548;
  margin: 0;

  @media (max-width: 1365px) {
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    max-width: 344px;
    margin: 0 auto;
    padding-bottom: 8px;
  }
`;

export const Text = styled.p`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 27px;
  color: #ffffff;
  max-width: ${(props) => props.width};
  margin: 8px 0;

  strong {
    font-weight: 700;
    color: #ffffff;
  }

  @media (max-width: 1365px) {
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    max-width: 320px;
    margin: 8px auto;
  }
`;

export const Button = styled.button`
  background: #FFE600;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 16px 40px;
  cursor: pointer;
  margin-top: 24px;
  border: none;

  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  color: #000000;

  @media (max-width: 1365px) {
    font-size: 16px;
    line-height: 22px;
  }
`;
